<script>
  import { afterNavigate } from '$app/navigation'

  import { setLanguage, setCurrency } from '$lib/context.js'
  import { repositoryName } from '$lib/prismic.js'
  import { track } from '$lib/plausible.svelte.js'
  import State from '$lib/utils/state.svelte.js'
  import Intercom from '$lib/Intercom.svelte'
  import Config from '$lib/Config.svelte'

  let { data, children } = $props()

  State.origin = data.origin

  afterNavigate(() => {
    track('pageview')
  })

  $effect(() => {
    State.language = data.language
    setLanguage(data.language)
  })

  $effect(() => {
    State.currency = data.currency
    setCurrency(data.currency)
  })
</script>

<Config>
  {@render children()}
</Config>

{#if data.agent.settings?.data.enable_intercom}
  <Intercom />
{/if}

<svelte:head>
  {#if data.previewToken}
    <script
      async
      defer
      src="https://static.cdn.prismic.io/prismic.js?new=true&repo={repositoryName}"></script>
  {/if}
</svelte:head>
